function InsightCard({ title, subtitle, children, className = '' }) {
  return (
    <div className={`bg-white dark:bg-gray-800/50 rounded-xl border border-gray-200/60 dark:border-gray-700/40 ${className}`}>
      {(title || subtitle) && (
        <div className="px-5 pt-4 pb-3 border-b border-gray-100 dark:border-gray-700/30">
          <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">{title}</h3>
          {subtitle && <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
      )}
      <div className="px-5 py-4">{children}</div>
    </div>
  )
}

export default InsightCard
